import script from "./ItemsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemsModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__